module.exports = __webpack_public_path__ + "img/usa-other-heart-diseases-female.e8035cb6.png";